export default __webpack_public_path__ + "static/CanopyStyle-27d5080d0c2a28d62887ea2c3e1e0b98.png";